import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";
import client from "./graphql/client";
import TagManager from "react-gtm-module";

const root = ReactDOM.createRoot(document.getElementById("root"));

// GTM初期化
if(process.env.REACT_APP_GTM_CONTAINER_ID) {
  const tagManagerArgs = {
    id: process.env.REACT_APP_GTM_CONTAINER_ID,
    events: {},
    dataLayer: undefined,
    dataLayerName: "dataLayer",
    auth: "",
    preview: "",
  };

  const gtm = TagManager.gtm(tagManagerArgs);
  document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
}

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
